import { ButtonPrimary } from "components/Atoms/Button";
import { ContactHeader } from "components/PurpleHeader/ContactHeader";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { ContactSidePanelDetails } from "./ContactSidePanelDetails";
import { useOpenSidePanel } from "../SidePanel";
import { RightClickMenu } from "components/RightClickMenu/RightClickMenuContext";
import { rightMenuForSidePanel } from "components/RightClickMenu/rightClickMenuUtils";


interface ContactSidePanelProps {
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
  contactId: number
}

export const ContactSidePanel = (props: ContactSidePanelProps) => {
  if (!site.permissions.addressBook.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    detailUrl={routes.contact_Detail(props.contactId).absolute}
    apiCall={() => window.CoreApi.Contact.GetSidePanelData(props.contactId)}
    apiKey="contact"
    entityId={props.contactId}
    title={RESX.Contact.resxContact}
    headerContent={data => <ContactHeader contact={data.contact} />}
    footerContent={
      <ButtonPrimary href={routes.contact_Detail(props.contactId).absolute} label={RESX.Buttons.DetailView} />
    }
    trigger={<RightClickMenu menuItems={rightMenuForSidePanel(routes.contact_Detail(props.contactId).absolute)}>{props.trigger}</RightClickMenu>}
  >
    {(sidePanelData, refetch) => <ContactSidePanelDetails
      sidePanelData={sidePanelData}
      refetch={refetch}
    />}
  </DetailSidePanel>;
};

export const useOpenContactSidePanel = () => {
  const openSidePanel = useOpenSidePanel();

  const openContactSidePanel = React.useCallback((contactId: number) => {
    openSidePanel(<DetailSidePanel
      apiCall={() => window.CoreApi.Contact.GetSidePanelData(contactId)}
      apiKey="contact"
      entityId={contactId}
      title={RESX.Contact.resxContact}
      headerContent={data => <ContactHeader contact={data.contact} />}
      footerContent={
        <ButtonPrimary href={routes.contact_Detail(contactId).absolute} label={RESX.Buttons.DetailView} />
      }
      skipSidePanelBase
    >
      {(sidePanelData, refetch) => <ContactSidePanelDetails
        refetch={refetch}
        sidePanelData={sidePanelData}
      />}
    </DetailSidePanel>, `contact-side-${contactId}`);

  }, [openSidePanel]);

  return openContactSidePanel;
}